var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionsColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OptionsColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 190,
    height: 150
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693113%",
    x2: "99.999575%",
    y2: "27.7870935%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.7%",
    y: "-23.5%",
    width: "137.4%",
    height: "147.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.3862318,4.96198133 C90.1063349,1.65779408 99.3806188,1.65776366 105.100722,4.96195091 L170.696648,42.8527816 C173.776273,44.6316973 175.197872,47.0056636 174.961446,49.3339386 L174.986755,49.3339386 L174.986755,84.2223206 L174.961446,84.2223206 C174.758725,86.2186498 173.337126,88.1813951 170.696648,89.7066667 L105.100722,127.597497 C99.3806188,130.901685 90.1063349,130.901685 84.3862318,127.597497 L18.7903061,89.7066667 C16.1498279,88.1813951 14.7282286,86.2186498 14.525508,84.2223206 L14.5001984,84.2223206 L14.5001984,49.3339386 L14.525508,49.3339386 C14.2890818,47.0056636 15.7106811,44.6316973 18.7903061,42.8527816 L84.3862318,4.96198133 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.7%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8133345%",
    x2: "93.8547498%",
    y2: "50.7911126%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8871131%",
    x2: "93.8547498%",
    y2: "50.7419267%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.0315011,39.3230897 C61.5329845,37.3294783 71.9996101,29.853387 80.4725034,34.8374416 C87.2508183,38.8246852 114.031811,54.1091003 126.824218,61.2529212 C127.821029,61.7513266 130.014013,63.3462278 130.811462,65.7385741 C131.60891,68.1309204 123.667646,71.0549066 119.348132,72.716258 L62.0315011,39.3230897 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.2%",
    y: "-3.8%",
    width: "104.4%",
    height: "107.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.6229926,51.9715892 C38.124476,49.9779778 48.5911016,42.5018865 57.0639949,47.4859411 C63.8423098,51.4731847 90.623302,66.7575998 103.415709,73.9014207 C104.41252,74.3998261 106.605504,75.9947273 107.402953,78.3870736 C108.200402,80.7794198 100.259138,83.7034061 95.9396231,85.3647575 L38.6229926,51.9715892 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.2%",
    y: "-3.8%",
    width: "104.4%",
    height: "107.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.4794839,26.0545042 C82.9809673,24.0608928 93.4475929,16.5848015 101.920486,21.568856 C108.698801,25.5560997 135.479793,40.8405148 148.272201,47.9843356 C149.269012,48.4827411 151.461996,50.0776422 152.259444,52.4699885 C153.056893,54.8623348 145.115629,57.786321 140.796114,59.4476725 L83.4794839,26.0545042 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.2%",
    y: "-3.8%",
    width: "104.4%",
    height: "107.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "20.6246956%",
    x2: "99.999575%",
    y2: "26.3845593%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.2658234,27.8291322 L86.2658234,23.09428 C86.2658234,21.6512039 87.2195592,20.2080669 89.1265443,19.1070361 C92.9405143,16.9049137 99.1245873,16.9049137 102.938557,19.1070361 C104.845542,20.2080669 105.799278,21.6512039 105.799278,23.09428 L105.799278,27.8291322 C105.799278,29.2722083 104.845542,30.7153453 102.938557,31.816376 C99.1245873,34.0184376 92.9405143,34.0184376 89.1265443,31.816376 C87.2195592,30.7153453 86.2658234,29.2722083 86.2658234,27.8291322 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.7%",
    y: "-9.4%",
    width: "115.4%",
    height: "118.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "20.6246956%",
    x2: "99.999575%",
    y2: "-19.7783424%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.2326202,53.9440614 L41.2326202,49.2092092 C41.2326202,47.7661331 42.1863561,46.3229961 44.0933411,45.2219653 C47.9073112,43.0198429 54.0913842,43.0198429 57.9053542,45.2219653 C59.8123393,46.3229961 60.7660751,47.7661331 60.7660751,49.2092092 L60.7660751,53.9440614 C60.7660751,55.3871375 59.8123393,56.8302745 57.9053542,57.9313052 C54.0913842,60.1333668 47.9073112,60.1333668 44.0933411,57.9313052 C42.1863561,56.8302745 41.2326202,55.3871375 41.2326202,53.9440614 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.7%",
    y: "-9.4%",
    width: "115.4%",
    height: "118.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.011071,26.905602 C99.1969318,29.1076962 93.0129984,29.107696 89.19886,26.905602 C85.3847215,24.7035081 85.3847213,21.1332091 89.19886,18.9311149 C93.0129986,16.7290208 99.1969397,16.729021 103.011078,18.9311149 C106.825217,21.1332088 106.825209,24.7035079 103.011071,26.905602 Z M58.1213634,52.8226889 C54.3072247,55.0247831 48.1232856,55.0247828 44.3091471,52.8226889 C40.4950087,50.620595 40.4950084,47.050296 44.3091471,44.8482018 C48.1232858,42.6461077 54.3072287,42.6461079 58.1213672,44.8482018 C61.9355056,47.0502957 61.9355021,50.6205948 58.1213634,52.8226889 Z M110.780442,57.3083341 C114.59458,55.10624 120.778522,55.1062402 124.59266,57.3083341 C128.406798,59.510428 128.406799,63.0807271 124.59266,65.2828212 C120.778521,67.4849154 114.59458,67.4849151 110.780442,65.2828212 C106.966303,63.0807273 106.966303,59.5104283 110.780442,57.3083341 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.7%",
    y: "-3.0%",
    width: "103.5%",
    height: "106.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-23"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.6577492,4.47735586 C90.3605576,1.17421511 99.6066431,1.17421439 105.309452,4.47735515 L170.706497,42.3561708 C176.409308,45.6593123 176.409307,51.0147602 170.706497,54.3179015 L105.309444,92.1967152 C99.6066341,95.4998572 90.3605595,95.4998643 84.6577492,92.1967228 L19.2607035,54.3179053 C13.5578955,51.014765 13.5578936,45.6593166 19.260704,42.3561746 Z M58.942003,43.3775955 C54.146534,41.1090545 47.0589438,41.2669848 42.5826208,43.8513909 C38.1062978,46.4357971 37.8327529,50.5278192 41.7619812,53.2964844 L41.7193567,53.3210944 L87.4723279,79.7365791 L87.5149543,79.7119691 C92.3104234,81.9805101 99.3980135,81.8225798 103.874337,79.2381737 C108.35066,76.6537675 108.624204,72.5617454 104.694976,69.7930802 L104.737595,69.7684702 L58.9846294,43.3529855 Z M81.3868547,30.4190501 C76.5913856,28.1505091 69.5037993,28.3084413 65.0274763,30.8928475 C60.5511533,33.4772537 60.2776046,37.5692776 64.2068328,40.3379428 L64.1642103,40.362549 L109.917183,66.7780376 L109.959802,66.7534276 C114.755271,69.0219686 121.842869,68.8640383 126.319192,66.2796321 C130.795515,63.695226 131.069052,59.6032039 127.139824,56.8345387 L127.18245,56.8099287 L81.4294811,30.3944401 Z M103.831718,17.4605067 C99.0362487,15.1919657 91.9486509,15.3498979 87.4723279,17.934304 C82.9960049,20.5187102 82.72246,24.6107323 86.6516883,27.3793975 L86.6090619,27.4040075 L132.362031,53.819496 L132.404658,53.794886 C137.200127,56.0634271 144.287724,55.9054967 148.764047,53.3210906 C153.24037,50.7366844 153.513908,46.6446585 149.584679,43.8759933 L149.627313,43.8513871 L103.874337,17.4358976 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-26"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OptionsColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Options",
    transform: "translate(-0.387802, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3862318,12.4781556 C90.1063349,9.1739684 99.3806188,9.17393798 105.100722,12.4781252 L170.696648,50.3689559 C173.776273,52.1478716 175.197872,54.5218379 174.961446,56.8501129 L174.986755,56.8501129 L174.986755,91.7384949 L174.961446,91.7384949 C174.758725,93.7348241 173.337126,95.6975694 170.696648,97.222841 L105.100722,135.113672 C99.3806188,138.417859 90.1063349,138.417859 84.3862318,135.113672 L18.7903061,97.222841 C16.1498279,95.6975694 14.7282286,93.7348241 14.525508,91.7384949 L14.5001984,91.7384949 L14.5001984,56.8501129 L14.525508,56.8501129 C14.2890818,54.5218379 15.7106811,52.1478716 18.7903061,50.3689559 L84.3862318,12.4781556 Z",
    id: "Glow",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    opacity: 0.899999976,
    filter: "url(#filter-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.5957772,4.85537901 C89.9251099,1.69330807 98.5656738,1.69330783 103.895006,4.85537854 L165.009207,41.1164733 C170.338541,44.278545 170.33854,49.4052741 165.009207,52.5673455 L103.895,88.8284415 C98.5656718,91.9905101 89.9251115,91.9905207 84.5957772,88.8284491 L23.4815734,52.5673493 C18.1522403,49.4052784 18.1522395,44.2785454 23.4815738,41.1164733 L84.5957772,4.85537901 Z",
    id: "Subtract",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-43",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector-44",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector-45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cap-body",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-15)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-18)",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-20)",
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.89473,65.9057923 L107.89473,61.1709402 C107.89473,59.727864 108.848465,58.2847271 110.755451,57.1836963 C114.569421,54.9815739 120.753494,54.9815739 124.567464,57.1836963 C126.474449,58.2847271 127.428185,59.727864 127.428185,61.1709402 L127.428185,65.9057923 C127.428185,67.3488685 126.474449,68.7920054 124.567464,69.8930362 C120.753494,72.0950978 114.569421,72.0950978 110.755451,69.8930362 C108.848465,68.7920054 107.89473,67.3488685 107.89473,65.9057923 Z",
    id: "Union",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-21)",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-23)",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-24)",
    fillRule: "evenodd",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-26)",
    xlinkHref: "#path-25"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsColor);
export default __webpack_public_path__ + "static/media/OptionsColor.88c74fcc784b64f8822ecf35da94e246.svg";
export { ForwardRef as ReactComponent };